export interface ImageFile {
  link: string;
  fileLocation: string;
  fileExtension: string;
}

export enum Gender {
  male = 'male',
  female = 'female',
}

export enum Language {
  english = 'en',
  arabic = 'ar'
}

export interface Rating {
  numberOfStars: number;
  numberOfReviews: number;
}

export interface ViewData {
  name: string | null;
  pictureUrl?: string | null;
}

export interface ViewDataExtra {
  name: string;
  nameAr: string;
  pictureUrl: string;
}

export enum PaymentMethod {
  card = 'card',
  cash = 'cash'
}

export interface ContactNumber {
  dialCode: string;
  internationalNumber: string;
  isoCode: string;
  nationalNumber: string;
}

export interface OpeningDays {
  sunday: { available: boolean; time: TimeRange[] };
  monday: { available: boolean; time: TimeRange[] };
  tuesday: { available: boolean; time: TimeRange[] };
  wednesday: { available: boolean; time: TimeRange[] };
  thursday: { available: boolean; time: TimeRange[] };
  friday: { available: boolean; time: TimeRange[] };
  saturday: { available: boolean; time: TimeRange[] };
}

export interface TimeRange {
  start: string;
  end: string;
}

// Invoice
export interface InvoiceItem {
  amount: number;
  currency: string;
  description: string;
}

// Google maps objects
export interface Address {
  id?: string;
  label?: string;
  addressComponent: AddressComponent[];
  addressFull: string;
  addressExtra: string;
  placeId: string;
  utcOffset: number;
  location: Coordinates;
}

export interface AddressComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention,camelcase
  long_name: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention,camelcase
  short_name: string;
  types: string[];
}

export interface Coordinates {
  longitude: number;
  latitude: number;
}
